export default __webpack_public_path__ + "static/media/sidebar-cbp-light-disabled.3e4a93f8.svg";